/**
 * Mobile menu collapse/expandable submenus
 */
import { DESKTOP } from './constants'

class SubMenuToggle {
    constructor(element) {
        this.toggler = element
        this.subMenu = null
        this.height = -1

        this.toggler.addEventListener('click', () => {
            if (this.toggler.classList.contains('toggled')) {
                this.close()
            } else {
                this.open()
            }
        })
    }

    setHeight() {
        if (window.innerWidth < DESKTOP) {
            if (this.height === -1) {
                this.height = this.subMenu.getBoundingClientRect().height
            }
        }
    }

    init() {
        if (this.subMenu != null) {
            this.open()
            this.setHeight()
            return
        }

        for (let sibling of this.toggler.parentNode.children) {
            if (sibling != this.toggler) {
                if (sibling.classList.contains('sub-menu-wrap')) {
                    this.subMenu = sibling
                    this.clear()
                    this.setHeight()
                    break
                }
            }
        }
    }

    clear() {
        this.subMenu.classList.remove('closed')
        this.subMenu.classList.remove('open')
    }

    open() {
        if (window.innerWidth < DESKTOP) {
            this.toggler.classList.add('toggled')
            if (this.subMenu != null) {
                this.subMenu.style['max-height'] = this.height + 'px'
                this.subMenu.classList.add('open')
                this.subMenu.classList.remove('closed')
            }
        } else {
            this.clear()
        }
    }

    close() {
        if (window.innerWidth < DESKTOP) {
            this.toggler.classList.remove('toggled')
            if (this.subMenu != null) {
                this.subMenu.style['max-height'] = '0px'
                this.subMenu.classList.remove('open')
                this.subMenu.classList.add('closed')
            }
        } else {
            this.clear()
        }
    }
}

/**
 * initialize all subToggles.  we do this first because we need them all open to calculate heights
 */
const initAllSubMenuToggles = () => {
    var subToggles = []
    var subToggleElements = document.querySelectorAll('.sub-toggle')
    subToggleElements.forEach((element) => {
        subToggles.push(new SubMenuToggle(element))
    })

    const initAllToggles = () => {
        // Submenus on mobile need to be initialized as opened to calculate heights
        subToggles.forEach((subToggle) => {
            subToggle.init()
        })

        subToggles.forEach((subToggle) => {
            subToggle.close()
        })
    }

    initAllToggles()
    window.addEventListener('resize', initAllToggles)
}

export const SubMenuFlipper = () => {
    // desktop submenus need to flip if they touch right side of the screen
    const flipSubMenus = () => {
        let subMenus = document.querySelectorAll('.sub-menu-wrap')
        subMenus.forEach((subMenu) => {
            const right = subMenu.getBoundingClientRect().right
            const max = Math.max(document.documentElement.clientWidth || 0, window.width || 0)

            if(right > max - 50) {
                subMenu.classList.add('flipped')
            }
            else {
                subMenu.classList.remove('flipped')
            }
        })
    }

    flipSubMenus()
    window.addEventListener('resize', flipSubMenus)
}

export default initAllSubMenuToggles
